import * as z from "zod";

export const formSchema = z.object({
  // General Info
  centerName: z.string().min(2, "Il nome del centro è obbligatorio"),
  ownerName: z.string().min(2, "Il nome del titolare è obbligatorio"),
  phoneNumber: z.string().min(10, "Inserisci un numero valido"),
  email: z.string().email("Inserisci un'email valida"),
  address: z.string().min(5, "L'indirizzo è obbligatorio"),
  city: z.string().min(2, "La città è obbligatoria"),
  province: z.string().min(2, "La provincia è obbligatoria"),
  zipCode: z.string().min(5, "Il CAP è obbligatorio"),
  website: z.string().optional(),
  landmarks: z.string().optional(),

  // Treatments
  mainTreatment: z.string().min(10, "Descrivi il trattamento principale"),
  treatmentReason: z.string().min(10, "Spiega il motivo della promozione"),
  differentiators: z.string().min(10, "Descrivi cosa ti differenzia"),
  shortTermResults: z.string().min(10, "Descrivi i risultati a breve termine"),
  longTermResults: z.string().optional(),
  recommendations: z.string().optional(),
  sessionDuration: z.string().optional(),

  // Clientele
  openingHours: z.string().min(5, "Indica gli orari di apertura"),
  clientRadius: z.string().min(1, "Indica il raggio d'azione"),

  // Communication
  appearInAds: z.string().min(2, "Specifica la tua disponibilità"),
  voiceInAds: z.string().optional(),
  competitors: z.string().optional(),

  // Offers
  currentOffer: z.string().optional(),
  reasonForCollaboration: z.string().min(10, "Spiega perché hai scelto di collaborare"),
  expectations: z.string().min(10, "Descrivi le tue aspettative"),
  doubts: z.string().optional(),
});
